<div class="outer-container">

  <lib-title-bar
    [crumbs]="[{ 'label': 'Disputes' , 'link': '/dashboard/disputes' }, { 'label': pageTitle }]">
  </lib-title-bar>

  <div class="details-container">

    @if (!dispute) {
      <lib-busy-indicator>
      </lib-busy-indicator>
    }
    @if (dispute) {
      <div class="details-common-container">
        <lib-text-field [label]="'Date Created (' + LocalTimePoint.formatZ() + ')'">
          @if (dispute.raiseDateUtc) {
            <lib-date-time-label [singleLine]="true" [dateUtc]="dispute.raiseDateUtc"></lib-date-time-label>
          }
        </lib-text-field>
        <lib-text-field label="Case">
          {{ dispute.caseNumber }}
        </lib-text-field>
        <lib-text-field label="Type">
          {{ dispute.disputeType }}
        </lib-text-field>
        <lib-text-field label="Processor">
          {{ dispute.processor }}
        </lib-text-field>
        <lib-text-field label="Merchant Name">
          {{ dispute.organizationName }}
        </lib-text-field>
        <lib-text-field label="MID">
          {{ dispute.mid }}
        </lib-text-field>
        <lib-text-field label="Reason Type">
          {{ dispute.reasonCodeDescription }}
        </lib-text-field>
        <lib-text-field label="Amount">
          {{ dispute.disputeAmount | vituCurrencyUsd }}
        </lib-text-field>
        <lib-text-field label="Status">
          {{ dispute.statusDescription }}
        </lib-text-field>
        <lib-text-field [label]="'Date Updated (' + LocalTimePoint.formatZ() + ')'">
          @if (dispute.statusDateUtc) {
            <lib-date-time-label [singleLine]="true" [dateUtc]="dispute.statusDateUtc"></lib-date-time-label>
          }
        </lib-text-field>
        <lib-text-field label="Outcome">
          {{ dispute.disputeOutcome }}
        </lib-text-field>
        <lib-text-field [label]="'Date Due (' + LocalTimePoint.formatZ() + ')'">
          @if (dispute.dueDateUtc) {
            <lib-date-time-label [singleLine]="true" [dateUtc]="dispute.dueDateUtc"></lib-date-time-label>
          }
        </lib-text-field>
        <lib-text-field label="Fees">
          {{ dispute.fees | vituCurrencyUsd }}
        </lib-text-field>
        <lib-text-field label="Payment Token">
          {{ dispute.paymentToken }}
        </lib-text-field>
        <lib-text-field label="Transaction ID">
          {{ dispute.publicTransactionId }}
        </lib-text-field>
        <lib-text-field label="Token">
          {{ dispute.token }}
        </lib-text-field>
      </div>
      <div class="form-buttons-line">
        <lib-action-button
          [kind]="ActionButtonKind.STROKED"
          largeButton
          label="Back"
          (click)="onCancel()">
        </lib-action-button>
      </div>
    }

  </div>

</div>


